import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { CatalogWords } from '../services/catalog-words';

/** The catalog in the language on screen; a language switch re-renders with the other words. */
export function useCatalogWords(): CatalogWords {
  const { t, i18n } = useTranslation('signup');
  const language = i18n.language;
  return useMemo(
    () => ({
      text: (keys) => t(typeof keys === 'string' ? keys : [...keys], { lng: language }),
      has: (key) => i18n.exists(key, { ns: 'signup', lng: language }),
    }),
    [t, i18n, language],
  );
}
